(function () {

  /*
   * Prevent accidental duplicate initialization.
   * This asset only needs to run once globally.
   */
  if (window.MWTierCampaignLoaded) {
    return;
  }

  window.MWTierCampaignLoaded = true;


  /* ========================================================
     CAMPAIGN CONFIG
  ======================================================== */

  const TIER_1 = 499;
  const TIER_2 = 799;
  const TIER_3 = 999;


  /* ========================================================
     MONEY
  ======================================================== */

  function mwMoney(value) {

    return Number(value).toLocaleString(
      'en-IN',
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }
    );

  }


  /* ========================================================
     TIER LOGIC
  ======================================================== */

  function mwGetTier(cartValue) {


    /*
     * BELOW ₹499
     */
    if (cartValue < TIER_1) {

      return {

        tier: 0,

        percentage: 0,

        saving: 0,

        message:
          'Add ₹' +
          mwMoney(TIER_1 - cartValue) +
          ' more to unlock Free Shipping + Style Credit up to ₹80.',

        announcement:
          'SHOP MORE, SAVE MORE | ADD ₹' +
          mwMoney(TIER_1 - cartValue) +
          ' MORE TO UNLOCK 10% OFF'

      };

    }


    /*
     * ₹499 - ₹798.99
     */
    if (cartValue < TIER_2) {

      const saving =
        cartValue * 0.10;


      return {

        tier: 1,

        percentage: 10,

        saving: saving,

        message:
          'Free Shipping + 10% Style Credit unlocked! Add ₹' +
          mwMoney(TIER_2 - cartValue) +
          ' more to unlock Style Credit up to ₹150.',

        announcement:
          '10% OFF UNLOCKED ✓ | ADD ₹' +
          mwMoney(TIER_2 - cartValue) +
          ' MORE TO UNLOCK 15% OFF'

      };

    }


    /*
     * ₹799 - ₹998.99
     */
    if (cartValue < TIER_3) {

      const saving =
        cartValue * 0.15;


      return {

        tier: 2,

        percentage: 15,

        saving: saving,

        message:
          'Free Shipping + 15% Style Credit unlocked! Add ₹' +
          mwMoney(TIER_3 - cartValue) +
          ' more to unlock Style Credit up to ₹300.',

        announcement:
          '15% OFF UNLOCKED ✓ | ADD ₹' +
          mwMoney(TIER_3 - cartValue) +
          ' MORE TO UNLOCK 20% OFF'

      };

    }


    /*
     * ₹999+
     */
    const saving =
      cartValue * 0.20;


    return {

      tier: 3,

      percentage: 20,

      saving: saving,

      message:
        'Maximum reward unlocked! Free Shipping + 20% Style Credit up to ₹300.',
      announcement:
        '20% OFF UNLOCKED ✓ | MAXIMUM SAVINGS ACTIVATED'

    };

  }


  /* ========================================================
     SEGMENTED PROGRESS

     Start -> ₹499 -> ₹799 -> ₹999
              33%     66%     100%
  ======================================================== */

  function mwCalculateProgress(cartValue) {

    const POSITION_499 = 33.333;
    const POSITION_799 = 66.666;
    const POSITION_999 = 100;

    const GAP = 1.2;


    /* BELOW ₹499 */

    if (cartValue < TIER_1) {

      const segment =
        cartValue / TIER_1;


      return Math.min(
        segment * POSITION_499,
        POSITION_499 - GAP
      );

    }


    /* EXACT ₹499 */

    if (cartValue === TIER_1) {

      return POSITION_499;

    }


    /* ₹500 - ₹798 */

    if (cartValue < TIER_2) {

      const segment =
        (cartValue - TIER_1) /
        (TIER_2 - TIER_1);


      const progress =
        POSITION_499 +
        (
          segment *
          (
            POSITION_799 -
            POSITION_499
          )
        );


      return Math.min(
        progress,
        POSITION_799 - GAP
      );

    }


    /* EXACT ₹799 */

    if (cartValue === TIER_2) {

      return POSITION_799;

    }


    /* ₹800 - ₹998 */

    if (cartValue < TIER_3) {

      const segment =
        (cartValue - TIER_2) /
        (TIER_3 - TIER_2);


      const progress =
        POSITION_799 +
        (
          segment *
          (
            POSITION_999 -
            POSITION_799
          )
        );


      return Math.min(
        progress,
        POSITION_999 - GAP
      );

    }


    return 100;

  }


  /* ========================================================
     UPDATE TOP ANNOUNCEMENT
  ======================================================== */

  function mwRenderAnnouncement(tier) {

    const messages =
      document.querySelectorAll(
        '.mw-announcement-message'
      );


    messages.forEach(function (element) {

      element.textContent =
        tier.announcement;

    });

  }


  /* ========================================================
     UPDATE CART PROGRESS
  ======================================================== */

  function mwRenderProgress(cartValue, tier) {

    const progress =
      mwCalculateProgress(cartValue);


    const widgets =
      document.querySelectorAll(
        '[data-mw-tier-widget]'
      );


    widgets.forEach(function (widget) {


      const message =
        widget.querySelector(
          '[data-mw-tier-message]'
        );


      const saving =
        widget.querySelector(
          '[data-mw-tier-saving]'
        );


      const fill =
        widget.querySelector(
          '[data-mw-progress-fill]'
        );


      if (message) {

        message.textContent =
          tier.message;

      }


      if (saving) {

        if (tier.percentage > 0) {

          saving.textContent =
            tier.percentage +
            '% Style Credit — You Save ₹' +
            mwMoney(tier.saving);

        }

        else {

          saving.textContent = '';

        }

      }


      if (fill) {

        fill.style.width =
          progress + '%';

      }


      const markers =
        widget.querySelectorAll(
          '[data-mw-marker]'
        );


      markers.forEach(function (marker) {

        const threshold =
          Number(
            marker.dataset.mwMarker
          );


        marker.classList.toggle(
          'is-unlocked',
          cartValue >= threshold
        );

      });

    });

  }


  /* ========================================================
     GET CURRENT CART
  ======================================================== */

  async function mwRefreshCampaign() {

    try {

      const root =
        (
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
        )
          ? window.Shopify.routes.root
          : '/';


      const response =
        await fetch(
          root + 'cart.js',
          {
            method: 'GET',

            headers: {
              Accept: 'application/json'
            },

            cache: 'no-store'
          }
        );


      if (!response.ok) {
        return;
      }


      const cart =
        await response.json();


      const cartValue =
        Number(
          cart.items_subtotal_price || 0
        ) / 100;


      const tier =
        mwGetTier(cartValue);


      mwRenderAnnouncement(tier);

      mwRenderProgress(
        cartValue,
        tier
      );

    }

    catch (error) {

      console.error(
        'MW campaign error:',
        error
      );

    }

  }


  window.mwRefreshCampaign =
    mwRefreshCampaign;


  /* ========================================================
     INITIAL LOAD
  ======================================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      mwRefreshCampaign
    );

  }

  else {

    mwRefreshCampaign();

  }


  /* ========================================================
     SHOPIFY/HORIZON EVENTS
  ======================================================== */

  [
    'cart:updated',
    'cart:update',
    'cart:change',
    'cart:refresh',
    'cart:add'
  ].forEach(function (eventName) {

    document.addEventListener(
      eventName,
      function () {

        setTimeout(
          mwRefreshCampaign,
          100
        );

        setTimeout(
          mwRefreshCampaign,
          500
        );

      }
    );

  });


  /* ========================================================
     AJAX FETCH WATCHER
  ======================================================== */

  if (!window.MWCartFetchWatcher) {

    window.MWCartFetchWatcher = true;


    const originalFetch =
      window.fetch.bind(window);


    window.fetch =
      async function (...args) {


        const response =
          await originalFetch(...args);


        try {

          let requestUrl =
            args[0];


          if (
            requestUrl &&
            typeof requestUrl !== 'string' &&
            requestUrl.url
          ) {

            requestUrl =
              requestUrl.url;

          }


          if (
            typeof requestUrl === 'string' &&
            (
              requestUrl.includes('/cart/add') ||
              requestUrl.includes('/cart/change') ||
              requestUrl.includes('/cart/update') ||
              requestUrl.includes('/cart/clear')
            )
          ) {

            setTimeout(
              mwRefreshCampaign,
              100
            );


            setTimeout(
              mwRefreshCampaign,
              400
            );


            setTimeout(
              mwRefreshCampaign,
              800
            );

          }

        }

        catch (error) {
          // Ignore cart monitoring errors.
        }


        return response;

      };

  }


  /* ========================================================
     HORIZON SECTION REPLACEMENT
  ======================================================== */

  let observerTimer;


  const observer =
    new MutationObserver(
      function (mutations) {


        let refreshNeeded = false;


        mutations.forEach(
          function (mutation) {


            mutation.addedNodes.forEach(
              function (node) {


                if (
                  node.nodeType !== 1
                ) {
                  return;
                }


                if (
                  node.matches?.(
                    '[data-mw-tier-widget]'
                  ) ||

                  node.querySelector?.(
                    '[data-mw-tier-widget]'
                  ) ||

                  node.matches?.(
                    '#cart-drawer'
                  ) ||

                  node.querySelector?.(
                    '#cart-drawer'
                  )
                ) {

                  refreshNeeded = true;

                }

              }
            );

          }
        );


        if (refreshNeeded) {

          clearTimeout(
            observerTimer
          );


          observerTimer =
            setTimeout(
              mwRefreshCampaign,
              100
            );

        }

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  /* ========================================================
     SHOPIFY THEME EDITOR
  ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(
        mwRefreshCampaign,
        100
      );

    }
  );


})();